 <div class="job-banner">
    <h2>LOOKING FOR JOB OPPORTUNITY</h2>
    <button class="apply-btn">APPLY HERE</button>
  </div>
 
  <!-- ROCKET DIVIDER -->
  <div class="rocket-divider">
    <i class="fa fa-rocket"></i>
  </div>
 
  <!-- SUPPORT CARD -->
  <div class="support-section">
    <div class="support-card">
      <h3><i class="fa fa-phone"></i>&nbsp; Support Center</h3>
      <p>04362 260060</p>
      <p>+91 98943 55288</p>
      <p>+91 74025 55888</p>
    </div>
  </div>
 
  <!-- MAIN FOOTER (JKR style) -->
  <footer class="main-footer">
    <div class="footer-inner">
      <!-- Column 1 : Brand / Contact Us -->
      <div class="footer-col">
        <h5 >Contact Us</h5>
        <div class="col-rule"></div>
        <div class="brand-logo">
          
        <div class="col-md-4">
          <a class="navbar-brand" href="#">
            <img class="logo-img" src="../../assets/img/icon/image (1).png" width="80px" alt="SB Consultancy" />&nbsp;
          </a> 
        </div>
          <!-- <div class="logo-circle">SB</div> -->
          <div class="brand-name">
            <span>SB Consultancy</span>
            <small>Recruitment &amp; Staffing</small>
            <small class="footer-text">  Approved By Ministry Of External Affairs,Government Of India.</small>
          </div>
        </div>
         <a href="tel:04362260060" class="contact-item"><i class="fa fa-phone"></i> 04362 260060</a>
        <a href="tel:+919894355288" class="contact-item"><i class="fa fa-mobile" style="font-size:18px"></i> +91 98943 55288</a>
        <a href="tel:+917402555888" class="contact-item"><i class="fa fa-mobile" style="font-size:18px"></i> +91 74025 55888</a>
        <a href="https://mail.google.com/mail/?view=cm&to=Info@sbconsultancy.org.in" target="_blank" class="contact-item">
          <i class="fa fa-envelope"></i> Info@sbconsultancy.org.in
        </a>
      </div>
 
      <!-- Column 2 : Where to Find Us -->
      <div class="footer-col">
        <h5 >Where to Find Us?</h5>
        <div class="col-rule"></div>
        <h4>Our Location</h4>
        <div class="location-pin">
  <i class="fa fa-map-marker"></i>

  <a href="https://maps.app.goo.gl/5rUgdQPSaenSR1YD8"
     target="_blank"
     class="address-link">

    Akila Complex, Shop No: B11 &amp; B12,<br>
    Odathurai Street, Thiruvaiyaru,<br>
    Thanjavur Dt — Pin 613204,<br>
    Tamil Nadu.

  </a>
</div>
        <!-- Simple inline world-map SVG (outline style) -->
        <div class="world-map-box">
          <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="0.8">
            <!-- simplified continents as rough outlines -->
            <!-- North America -->
            <path d="M30,40 Q55,30 80,35 Q95,38 100,55 Q105,70 95,90 Q85,110 70,120 Q55,125 45,110 Q30,95 25,75 Q20,55 30,40Z"/>
            <!-- South America -->
            <path d="M75,130 Q90,125 100,135 Q110,148 108,170 Q105,188 92,192 Q78,195 70,180 Q62,165 65,148 Q67,135 75,130Z"/>
            <!-- Europe -->
            <path d="M170,30 Q185,25 195,32 Q205,38 202,50 Q198,60 188,62 Q178,63 172,55 Q166,47 170,30Z"/>
            <!-- Africa -->
            <path d="M175,68 Q190,62 200,68 Q212,75 214,95 Q216,115 210,135 Q204,155 192,162 Q180,165 172,155 Q162,142 160,120 Q158,98 164,82 Q168,72 175,68Z"/>
            <!-- Asia -->
            <path d="M205,25 Q240,18 270,22 Q310,28 330,38 Q345,48 348,65 Q350,80 338,90 Q320,98 298,95 Q275,92 255,85 Q235,78 220,68 Q208,58 205,45 Q203,35 205,25Z"/>
            <!-- Australia -->
            <path d="M300,130 Q325,125 340,132 Q355,140 355,155 Q355,170 342,178 Q328,184 312,180 Q297,175 292,162 Q287,148 292,138 Q295,132 300,130Z"/>
            <!-- Location dot on India -->
            <circle cx="258" cy="78" r="4" fill="#fff" stroke="#E8A040" stroke-width="1.5"/>
            <circle cx="258" cy="78" r="7" fill="none" stroke="#fff" stroke-width="1" opacity="0.6">
              <animate attributeName="r" from="5" to="12" dur="1.5s" repeatCount="indefinite"/>
              <animate attributeName="opacity" from="0.8" to="0" dur="1.5s" repeatCount="indefinite"/>
            </circle>
          </svg>
        </div> 
        <!-- <div class="footer-text">
            Approved By Ministry Of External Affairs,Government Of India.
        </div> -->
      </div>
 
      <!-- Column 3 : Social Links -->
      <div class="footer-col">
        <h5 >Get in Touch</h5>
        <div class="col-rule"></div>
        <h4>Our Social Links</h4>
        <p class="social-desc">Connect with us for the latest job opportunities and industry updates.</p>
        <div class="social-icons">
          
          <a href="tel:9894355288" class="social-btn" title="phoneNo"><i class="fa fa-phone"></i></a>
          <a href="https://wa.me/+919894355288" class="social-btn" title="WhatsApp" target="_blank"><i class="fa fab fa-whatsapp"></i></a>
          <a href="https://mail.google.com/mail/?view=cm&to=Info@sbconsultancy.org.in" target="_blank" class="social-btn" title="Email"><i class="fa fa-envelope"></i></a>
          <a href="https://www.instagram.com/sbc3600?utm_source=qr&igsh=eDRnM2xrbXo2aDUx" target="_blank"  class="social-btn" title="instagram">
      <i class="fa fab fa-instagram"></i>
    </a>
    <a href="https://www.facebook.com/profile.php?id=61572205600780" target="_blank"  class="social-btn" title="facebook">
      <i class="fa fab fa-facebook" ></i>
    </a>
        </div>
      </div>
 
    </div>
 
    <!-- COPYRIGHT BAR -->
    <div class="copyright-bar">
      <span>&copy; 2025 <strong>SB Consultants.</strong> All rights reserved.</span>
      <div class="copyright-links">
            <a routerLink="/about-us" routerLinkActive="active" class="text-white">About Us</a>
            <a routerLink="/web-development" routerLinkActive="active" class="text-white">Services</a>
            <a routerLink="/verticals" routerLinkActive="active" class="text-white">Industries We Serve</a>
            <a routerLink="/ourproducts" routerLinkActive="active" class="text-white">Recruitment Process</a>
            <a routerLink="/upload-cv" routerLinkActive="active" class="text-white">Job Seeker</a>
            <a routerLink="/contact-us" routerLinkActive="active" class="text-white">Contact</a>
      </div>
      <a href="http://annaasilicontechnology.com/#/" target="_blank" style="font-size:0.72rem;">
        Designed by AnnaaSiliconTechnology.Pvt.Ltd.,®
      </a>
    </div>
  </footer>
 
  <!-- FLOATING CONTACT BUTTONS -->
  <!-- <div class="float-contact">
    <a href="tel:9894355288" class="float-btn phone" title="Call us"><i class="fa fa-phone"></i></a>
    <a href="mailto:Info@sbconsultancy.org.in" class="float-btn mail" title="Email us"><i class="fa fa-envelope"></i></a>
    <a href="https://wa.me/+919894355288" target="_blank" class="float-btn whatsapp" title="WhatsApp"><i class="fa fa-whatsapp"></i></a>
  </div> -->